import { ColorTokens } from '@voltmoney/schema';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { PrivateStackParamList } from '../../../../navigationApp/types';
import { ThemedText, ThemedView } from '../../../../theme';
import BackButton from '@sharedComponents/BackButton/BackButton';
import Typography from '@sharedComponents/typography/Typography';
import NeedHelp from '@sharedComponents/NeedHelp/NeedHelp';


type HeaderProp = NativeStackNavigationProp<PrivateStackParamList, 'FAQ'>;

const FaqHeader = ({ navigation }: { navigation: HeaderProp }) => {
  return (
    <ThemedView
      borderBottomWidth={1}
      flexDirection='row'
      justifyContent='space-between'
      backgroundColor='bg-surface-primary'
      padding='lg'
      alignItems='center'
      borderColor='border-secondary'
    >
      <ThemedView flexDirection='row' alignItems='center'>
        <ThemedView mr='sm'>
          <BackButton navigation={navigation} />
        </ThemedView>
        <ThemedText color='text-secondary' >
          FAQs
        </ThemedText>
        <Typography color={ColorTokens.Grey_Night} label='' />
      </ThemedView>
      <NeedHelp />
    </ThemedView>
  );
};

export default FaqHeader;
